import {BASE_URL_ASSETS} from "../utils";

export var leftAction = `${BASE_URL_ASSETS}/assets/icons/lAction.png`
export var animatedLoader = `${BASE_URL_ASSETS}/assets/icons/animationLoader.png`
export var rightAction = `${BASE_URL_ASSETS}/assets/icons/rAction.png`;